import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Spinner, Table } from "reactstrap";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Container from "../../../components/Container";
import AppLayout from "../../../components/layouts/AppLayout";
import API from "../../../utils/API";
import Create from "./Create";
import Delete from "./Delete";
import Edit from "./Edit";

const Index = () => {
  const [sessionsDetail, setSessionsDetail] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchSessionsDetail = async () => {
    try {
      const data = (await API.get("/api/session-details")).data.data;
      setSessionsDetail(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSessionsDetail();
  }, [refresh]);

  return (
    <AppLayout>
      <Breadcrumbs
        title="Sessions Detail"
        links={[
          {
            title: "Dashboard",
            link: null,
          },
          {
            title: "Sessions Detail",
            link: null,
          },
        ]}
      />
      <Container>
        <Card className="border-0 shadow mt-5" style={{ minHeight: "70vh" }}>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h1 className="mb-0">All Sessions</h1>
              <Create
                SessionDetail={sessionsDetail}
                fetchSessionsDetail={fetchSessionsDetail}
              />
            </div>
            <Table hover responsive>
              <thead>
                <tr className="bg-shade-blue">
                  <th>#</th>
                  <th>Campus</th>
                  <th>Session</th>
                  <th>Active</th>
                  <th>Next</th>
                  <th>Previous</th>
                  <th>Feedback Enabled</th>
                  <th>Enrollment Open</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {sessionsDetail.length > 0 ? (
                  sessionsDetail.map((sessiondetail, index) => (
                    <tr
                      key={`sessiondetail-${sessiondetail.id}`}
                      style={{ verticalAlign: "middle" }}>
                      <th scope="row">{index + 1}</th>
                      {/* <td>{sessiondetail.campus_id}</td> */}
                      <td>{sessiondetail.relationships.campus.name}</td>
                      {/* <td>{sessiondetail.session_id}</td> */}
                      <td>{sessiondetail.relationships.session.name}</td>
                      {sessiondetail.is_active == 1 ? (
                        <td>Yes</td>
                      ) : (
                        <td>No</td>
                      )}
                      {sessiondetail.is_next == 1 ? <td>Yes</td> : <td>No</td>}
                      {sessiondetail.is_previous == 1 ? (
                        <td>Yes</td>
                      ) : (
                        <td>No</td>
                      )}
                      {sessiondetail.is_feedback_enabled == 1 ? (
                        <td>Yes</td>
                      ) : (
                        <td>No</td>
                      )}
                      {sessiondetail.is_enrollment_open == 1 ? (
                        <td>Yes</td>
                      ) : (
                        <td>No</td>
                      )}
                      <td>
                        <Edit
                          sessionDetail={sessiondetail}
                          fetchSessionsDetail={fetchSessionsDetail}
                        />
                        <Delete
                          sessionDetail={sessiondetail}
                          refresh={refresh}
                          setRefresh={setRefresh}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={10} className="text-center">
                      {loading ? (
                        <Spinner style={{ width: "30px", height: "30px" }} />
                      ) : (
                        "No Session Exists"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
    </AppLayout>
  );
};

export default Index;
